class MessageItem {
  constructor() {
    this.ToUserId = '';
    this.Subject = '';
    this.Message = '';
  }
}

export default MessageItem;
